"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgZoomPlusFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M14.605 13.194l7 6.998a1 1 0 01-1.414 1.414h-.001l-6.997-7a7 7 0 111.412-1.412zM10 7c.003-.667-.33-1-.998-1C8.334 6 8 6.333 8 7v1H7c-.667-.005-1 .327-1 .993 0 .667.333 1 1 1l.994.024L8 11c-.001.667.332 1 1 1 .668 0 1.001-.333 1-1v-1l1-.007c.667 0 1-.33 1-.993 0-.662-.333-.995-1-1h-1V7z' }))); };
exports.default = SvgZoomPlusFilled;
//# sourceMappingURL=ZoomPlusFilled.js.map